import moment from "moment";

const disablePastDate = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();
  return yyyy + "-" + mm + "-" + dd;
};

const distributorQuick = "kagaminokankou";
const distributorRequest = "kagaminokankou_On";

const bodyProvider = {
  request: {
    Filter: {
      Type: "Provider",
      MustBeInAdCampaign: true,
      MustBeInDealCampaign: false,
      Bookability: {
        RateRange: {},
        IncludeOnRequest: true,
        IsBookable: true,
      },
    },
    Output: {
      CommonContent: {
        All: true,
      },
      Children: {
        Output: {
          CommonContent: {
            All: true,
          },
          Features: true,
          Rating: true,
          Reviews: {
            IncludeFullDescription: true,
            IncludeShortReview: true,
            MaxReturnCount: 10,
            MaxReturnCountSpecified: true,
          },
          Availability: {
            StartDate: new Date(),
            NumberOfDays: 4,
            MergeMethod: 2,
            FlagCampaign: true,
          },
        },
        Filter: {
          Ids: null,
          Type: 4,
        },
      },
      Rating: true,
      Reviews: {
        IncludeFullDescription: true,
        IncludeShortReview: true,
        MaxReturnCount: 10,
        MaxReturnCountSpecified: true,
      },
      Settings: true,
    },
    Paging: {
      PageNumber: 1,
      PageSize: 12,
    },
    ShortName: distributorQuick,
  },
};

const bodyRequest = {
  request: {
    Campaign: {
      AdCampaignCode: null,
      CampaignCodes: [],
      DealCampaignCode: null,
      Offers: {},
    },
    Filter: {
      Type: 3,
      MustBeInAdCampaign: true,
      MustBeInDealCampaign: false,
      Bookability: {
        RateRange: {},
        BlockUnavailableResults: false,
        IncludeOnRequest: true,
        IsBookable: true,
        NightsCapability: null,
        GuestsCapability: 0,
      },
      TagCriteria: {},
    },
    Output: {
      CommonContent: {
        All: true,
      },
      Children: {
        Filter: {
          Ids: null,
          Type: 4,
          TagCriteria: {},
        },
        Output: {
          CommonContent: {
            All: true,
          },
          Features: true,
          Rating: true,
          Reviews: {
            IncludeFullDescription: true,
            IncludeShortReview: true,
            MaxReturnCount: 10,
            MaxReturnCountSpecified: true,
          },
          Availability: {
            StartDate: moment().format("YYYY-MM-DD"),
            NumberOfDays: 7,
            MergeMethod: 2,
            FlagCampaign: true,
          },
        },
      },
      Parents: {
        Filter: {
          Ids: null,
          Type: "Provider",
          TagCriteria: {},
        },
        Output: {
          CommonContent: {
            All: true,
          },
          Rating: true,
          Reviews: {
            IncludeFullDescription: true,
            IncludeShortReview: true,
            MaxReturnCount: 10,
            MaxReturnCountSpecified: true,
          },
        },
      },
      Availability: {
        StartDate: new Date(),
        LowestRateOnly: true,
        MergeMethod: 2,
        NumberOfDays: 31,
      },
      AdvancedContent: true,
      Features: true,
      Rating: true,
      Reviews: {
        IncludeFullDescription: true,
        IncludeShortReview: true,
        MaxReturnCount: 10,
        MaxReturnCountSpecified: true,
      },
      Settings: true,
    },
    Paging: {
      Token: null,
      PageForEntityId: "",
      PageNumber: 1,
      PageSize: 12,
    },
    ShortName: distributorQuick,
    TransactionId: 1,
  },
};

const quoteRequest = {
  request: {
    CurrentCurrency: "JPY",
    AdCampaignCode: "",
    IncludeCampaigns: false,
    IncludeExtras: true,
    IndustryCategoryGroup: null,
    IndustryCategory: null,
    CommencementDate: new Date(),
    Duration: null,
    Language: "ja-JP",
    ExcludeProductsFromCampaigns: [],
    Configurations: [
      {
        Id: "",
        ProductId: "",
        Pax: {
          Adults: 2,
          Children: 0,
          Seniors: 0,
        },
      },
    ],
    Shortname: distributorQuick,
  },
};

const headers = {
  "Content-Type": "application/json",
};

export {
  bodyRequest,
  headers,
  quoteRequest,
  disablePastDate,
  distributorQuick,
  distributorRequest,
  bodyProvider,
};
